import { render, staticRenderFns } from "./brilliantShowList.vue?vue&type=template&id=47d2a2c4&scoped=true"
import script from "./brilliantShowList.vue?vue&type=script&lang=ts"
export * from "./brilliantShowList.vue?vue&type=script&lang=ts"
import style0 from "./brilliantShowList.vue?vue&type=style&index=0&id=47d2a2c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2a2c4",
  null
  
)

export default component.exports